import React from "react";
import { Box, Typography } from "@mui/material";
import { footerContent } from "../../data/footer";
import type { FooterProps } from "./Footer.types";
import "./Footer.styles.css";

export const Footer: React.FC<FooterProps> = () => {
  const handlePhoneClick = () => {
    window.location.href = `tel:${footerContent.contact.phone}`;
  };

  const handleEmailClick = () => {
    window.location.href = `mailto:${footerContent.contact.email}`;
  };

  return (
    <Box component="footer" className="footer-root">
      <Box className="footer-container">
        <Box className="footer-content">
          {/* Company Information */}
          <Box className="footer-section footer-company">
            <Typography className="footer-company-name">
              {footerContent.company.name}
            </Typography>
            <Typography className="footer-company-address">
              {footerContent.company.address}
            </Typography>
            <Typography className="footer-company-cvr">
              {footerContent.company.cvr}
            </Typography>
          </Box>

          {/* Contact Information */}
          <Box className="footer-section footer-contact">
            <a
              href={`tel:${footerContent.contact.phone}`}
              className="footer-contact-phone"
              onClick={(e) => {
                e.preventDefault();
                handlePhoneClick();
              }}
            >
              {footerContent.contact.phone}
            </a>
            <a
              href={`mailto:${footerContent.contact.email}`}
              className="footer-contact-email"
              onClick={(e) => {
                e.preventDefault();
                handleEmailClick();
              }}
            >
              {footerContent.contact.email}
            </a>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
